// extracted by mini-css-extract-plugin
module.exports = {"list":"list--IBnpF","item":"item--K5ucl","title":"title--3O22p","time":"time--1EytJ"};